// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-swatch {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 0.5px solid #1e1e1e;
  cursor: pointer;
}

.custom-tab-nav .nav-link {
  border-radius: 0.5rem;
  margin-bottom: 10px;
  padding: 12px 15px;
  color: #333;
  background-color: #f8f9fa;
  font-weight: 500;
  transition: all 0.3s ease;
  text-align: left;
}

.custom-tab-nav .nav-link:hover {
  background-color: #e2e6ea;
  color: #000;
}

.custom-tab-nav .nav-link.active {
  background-color: #0d6efd;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.tab-content h4 {
  font-weight: 600;
  margin-bottom: 15px;
}

.img-zoom {
  position: relative;
}
.img-zoom .btn {
  opacity: 0;
  visibility: hidden;
  transform: translateY(0);
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.img-zoom img {
  transition: transform 0.4s ease, filter 0.4s ease;
  width: 100%;
  display: block;
  border-radius: 20px;
}
.img-zoom:hover img {
  transform: scale(1.03);
  filter: brightness(75%);
}
.img-zoom:hover .btn {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

/* Always-visible overlay with fade background on hover */
.hover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  pointer-events: none;
  z-index: 2;
}

.overlay-content {
  pointer-events: auto;
}

.overlay-text {
  color: #fff;
  font-size: 1.3rem;
  font-weight: bold;
  text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
}

.info-card i {
  color: #000;
}

.info-card-custom {
  background-color: #f7f7f7;
  height: 100%;
  transition: transform 0.3s ease;
  border-radius: 12px;
  padding: 2rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}
.info-card-custom .card-icon {
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: start;
}
.info-card-custom .card-info-rt {
  width: calc(100% - 100px);
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: start;
}
.info-card-custom .card-info-rt .card-short-ct {
  color: var(--black);
  text-align: start;
}
.info-card-custom .card-info-rt .card-short-title {
  font-size: 16px;
  font-weight: 600;
}

.icon-theme {
  color: var(--secondary);
  font-size: 40px;
}

.small-text {
  font-size: 16px;
  line-height: 1.6;
  max-width: 75%;
  margin: 30px auto;
  opacity: 0.7;
}

.info-card-custom:hover {
  transform: translateY(-5px);
  border-bottom: 1px solid var(--secondary);
}

/**************************************************************home start*************************************/
/*home slider start*/
.hero-carousel {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 9;
  background: #ffffff;
}
.hero-carousel .carousel {
  height: 100%;
}
.hero-carousel .carousel .carousel-fade .carousel-item {
  transition: opacity 700ms linear;
  opacity: 0;
  transform: scale(1.05);
}
.hero-carousel .carousel .carousel-fade .carousel-item.active {
  opacity: 1;
  transform: scale(1);
  z-index: 1;
}
.hero-carousel .carousel .carousel-inner {
  height: 100%;
}
.hero-carousel .carousel .carousel-inner .carousel-item {
  height: 100%;
  background-color: #ffffff;
  transition: opacity 0.7s ease, transform 0.7s ease;
}
.hero-carousel .carousel .carousel-inner .carousel-item.active {
  height: 100%;
}
.hero-carousel .carousel .item {
  height: 100%;
}
.hero-carousel .carousel-indicators {
  z-index: 9;
  margin-bottom: 0;
  bottom: 40px;
}
.hero-carousel .carousel-indicators .indicator_btn {
  background: var(--white);
  border-radius: 30px;
  width: 50px;
  height: 1px;
  border-top: 1px solid transparent;
}
.hero-carousel .carousel-indicators .indicator_btn.active {
  background: var(--primary);
}
.hero-carousel .carousel-control-prev {
  display: none;
}
.hero-carousel .carousel-control-next {
  display: none;
}

.mobile-carousel {
  position: relative;
  z-index: 9;
  background: #ffffff;
  margin-top: 20px;
}
.mobile-carousel .carousel-item img {
  object-fit: cover;
}

/*home slider End*/`, "",{"version":3,"sources":["webpack://./src/app/components/home/home.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,eAAA;AACJ;;AAEA;EACI,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,mDAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAGA;EACI,kBAAA;AAAJ;AACI;EACI,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,kDAAA;AACR;AACI;EACI,iDAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AACR;AAEQ;EACI,sBAAA;EACA,uBAAA;AAAZ;AAEQ;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;AAAZ;;AAKA,yDAAA;AACA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,oBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,2CAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,YAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAGI;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AADR;AAGI;EACI,yBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AADR;AAEQ;EACI,mBAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,eAAA;EACA,gBAAA;AAAZ;;AAKA;EACI,uBAAA;EACA,eAAA;AAFJ;;AAKA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,2BAAA;EACA,yCAAA;AAFJ;;AAMA,8GAAA;AACA,oBAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AAHJ;AAKI;EACI,YAAA;AAHR;AAMY;EACI,gCAAA;EACA,UAAA;EAEA,sBAAA;AALhB;AAMgB;EACI,UAAA;EACA,mBAAA;EACA,UAAA;AAJpB;AASQ;EACI,YAAA;AAPZ;AASY;EACI,YAAA;EACA,yBAAA;EAEA,kDAAA;AARhB;AAUgB;EACI,YAAA;AARpB;AAiCQ;EACI,YAAA;AA/BZ;AAmCI;EACI,UAAA;EACA,gBAAA;EACA,YAAA;AAjCR;AAmCQ;EACI,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;AAjCZ;AAmCY;EACI,0BAAA;AAjChB;AAsCI;EACI,aAAA;AApCR;AAuCI;EACI,aAAA;AArCR;;AAyCA;EACI,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AAtCJ;AAwCQ;EACI,iBAAA;AAtCZ;;AA0CA,kBAAA","sourcesContent":[".color-swatch {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    border: 0.5px solid #1e1e1e;\n    cursor: pointer;\n}\n\n.custom-tab-nav .nav-link {\n    border-radius: 0.5rem;\n    margin-bottom: 10px;\n    padding: 12px 15px;\n    color: #333;\n    background-color: #f8f9fa;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    text-align: left;\n}\n\n.custom-tab-nav .nav-link:hover {\n    background-color: #e2e6ea;\n    color: #000;\n}\n\n.custom-tab-nav .nav-link.active {\n    background-color: #0d6efd;\n    color: #fff;\n    font-weight: 600;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.tab-content h4 {\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n\n.img-zoom {\n    position: relative;\n    & .btn {\n        opacity: 0;\n        visibility: hidden;\n        transform: translateY(0);\n        transition: opacity 0.3s ease, transform 0.3s ease;\n    }\n    & img {\n        transition: transform 0.4s ease, filter 0.4s ease;\n        width: 100%;\n        display: block;\n        border-radius: 20px;\n    }\n    &:hover {\n        & img {\n            transform: scale(1.03);\n            filter: brightness(75%);\n        }\n        & .btn {\n            opacity: 1;\n            visibility: visible;\n            transform: translateY(0);\n        }\n    }\n}\n\n/* Always-visible overlay with fade background on hover */\n.hover-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.overlay-content {\n    pointer-events: auto;\n}\n\n.overlay-text {\n    color: #fff;\n    font-size: 1.3rem;\n    font-weight: bold;\n    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);\n}\n\n.info-card i {\n    color: #000;\n}\n\n.info-card-custom {\n    background-color: #f7f7f7;\n    height: 100%;\n    transition: transform 0.3s ease;\n    border-radius: 12px;\n    padding: 2rem;\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: center;\n    align-items: center;\n    & .card-icon {\n        width: 100px;\n        display: flex;\n        justify-content: center;\n        align-items: start;\n    }\n    & .card-info-rt {\n        width: calc(100% - 100px);\n        display: flex;\n        flex-wrap: wrap;\n        align-items: start;\n        justify-content: start;\n        & .card-short-ct {\n            color: var(--black);\n            text-align: start;\n        }\n        & .card-short-title {\n            font-size: 16px;\n            font-weight: 600;\n        }\n    }\n}\n\n.icon-theme {\n    color: var(--secondary);\n    font-size: 40px;\n}\n\n.small-text {\n    font-size: 16px;\n    line-height: 1.6;\n    max-width: 75%;\n    margin: 30px auto;\n    opacity: 0.7;\n}\n\n.info-card-custom:hover {\n    transform: translateY(-5px);\n    border-bottom: 1px solid var(--secondary);\n}\n\n\n/**************************************************************home start*************************************/\n/*home slider start*/\n.hero-carousel {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    z-index: 9;\n    background: #ffffff;\n\n    & .carousel {\n        height: 100%;\n\n        & .carousel-fade {\n            & .carousel-item {\n                transition: opacity 700ms linear;\n                opacity: 0;\n                //transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;\n                transform: scale(1.05); // Start slightly zoomed in\n                &.active {\n                    opacity: 1;\n                    transform: scale(1); // Zoom out to normal\n                    z-index: 1;\n                }\n            }\n        }\n\n        & .carousel-inner {\n            height: 100%;\n\n            & .carousel-item {\n                height: 100%;\n                background-color: #ffffff;\n                //transform: scale(1.1); // Slight zoom\n                transition: opacity 0.7s ease, transform 0.7s ease;\n\n                &.active {\n                    height: 100%;\n                }\n            }\n\n            //& .bg {\n            //    background-repeat: no-repeat;\n            //    background-size: cover;\n            //}\n\n            //& .bg1 {\n            //    background-image: url(\"../../../assets/website-images/HomepageSliderImage1920x1200.jpg\");\n            //    background-position: center top;\n            //}\n            //\n            //& .bg2 {\n            //    background-image: url(\"../../../assets/website-images/HomepageSliderImage1920x1200.jpg\");\n            //    background-position: center top;\n            //}\n            //\n            //& .bg3 {\n            //    background-image: url(\"../../../assets/website-images/HomepageSliderImage1920x1200.jpg\");\n            //    background-position: center top;\n            //}\n        }\n\n        & .item {\n            height: 100%;\n        }\n    }\n\n    & .carousel-indicators {\n        z-index: 9;\n        margin-bottom: 0;\n        bottom: 40px;\n\n        & .indicator_btn {\n            background: var(--white);\n            border-radius: 30px;\n            width: 50px;\n            height: 1px;\n            border-top: 1px solid transparent;\n\n            &.active {\n                background: var(--primary);\n            }\n        }\n    }\n\n    & .carousel-control-prev {\n        display: none;\n    }\n\n    & .carousel-control-next {\n        display: none;\n    }\n}\n\n.mobile-carousel {\n    position: relative;\n    z-index: 9;\n    background: #ffffff;\n    margin-top: 20px;\n    & .carousel-item {\n        & img {\n            object-fit: cover;\n        }\n    }\n}\n/*home slider End*/\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
